module.exports = {"key":"hello fillipino","submit":"Magbigay ng feedback","hide":"Itago ito","skip":"Laktawan ang susunod na tanong","placeholder":"Pakisalarawan kung ano ang nararamdaman mo tungkol dito..."}


//////////////////
// WEBPACK FOOTER
// ./src/translations/fl.json
// module id = 443
// module chunks = 0